import { render, staticRenderFns } from "./PasswordSetup.vue?vue&type=template&id=1da6f71a&scoped=true"
import script from "./PasswordSetup.vue?vue&type=script&lang=ts"
export * from "./PasswordSetup.vue?vue&type=script&lang=ts"
import style0 from "./PasswordSetup.vue?vue&type=style&index=0&id=1da6f71a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da6f71a",
  null
  
)

export default component.exports